<template>
  <div class="checklist-report-row">
    <div class="report-time qrw-label-lg qrw-text-content-base-tertiary">
      {{ formattedFormTime }}
    </div>
    <div class="report-card qrw-box-shadow-1dp" :class="{
      'qrw-box-shadow-2dp': cardHover
    }" @mouseenter="cardHover = true" @mouseleave="cardHover = false" @click="openReport">
      <div
        class="
          report-form-title
          qrw-label-lg
          w-100
          bold
          qrw-text-content-base-primary
        "
      >
        {{ form.title }}
      </div>
      <div
        class="report-scheduling gap-column-txs"
        :class="{
          expired: scheduleState.expired,
        }"
        v-if="scheduleState"
      >
        <BaseBadge
          variant="secondary"
          color="content-error-primary"
          v-if="scheduleState.expired"
        >
          <div class="qrw-text-content-base-inverse-primary">
            {{ $t("checklist_reports.expired") }}
          </div>
        </BaseBadge>
        <BaseBadge variant="secondary" color="background-base-secondary" v-else>
          <div class="qrw-text-content-base-secondary">
            {{ $t("checklist_reports.scheduled") }}
          </div>
        </BaseBadge>
        <div class="gap-column-1xs">
          <div class="gap-column-2xs" :class="{}">
            <BaseIcon icon="clock" size="sm" />
            <div class="qrw-label-md">
              {{ scheduleState.timeslot }}
            </div>
          </div>
          <BaseDivider color="border-base-tertiary" vertical style="height: 20px" />
          <div class="gap-column-2xs">
            <BaseIcon icon="calendar" size="sm" />
            <div class="qrw-label-md">
              {{ scheduleState.date }}
            </div>
          </div>
        </div>
      </div>
      <div class="report-user gap-row-3xs" v-if="formWaiter">
        <div class="qrw-label-xs qrw-text-content-base-secondary">
          Test Department
        </div>
        <div class="qrw-label-md qrw-text-content-base-primary">
          {{ formWaiter.name }}
        </div>
      </div>
      <div
        class="iqos-tooltip-helper-box"
        @mouseenter="completenessHover = true"
        @mouseleave="completenessHover = false"
      >
        <IQOSTooltip
          :backdrop="false"
          :earPosition="'bottom'"
          v-show="completenessHover"
        >
          {{ $t("checklist_reports.completeness_hint") }}
        </IQOSTooltip>
        <div class="report-percent gap-row-3xs">
          <div class="qrw-label-xs qrw-text-content-base-secondary">
            {{ $t("checklist_reports.completeness") }}
          </div>
          <div class="qrw-label-md" :class="{
            [`${completenessColor}-color`]: true
          }">
            {{ form.complete_percent }}%
          </div>
        </div>
      </div>

      <div class="report-score gap-row-3xs">
        <div class="qrw-label-xs qrw-text-content-base-secondary">
          {{ $t("checklist_reports.total_score") }}
        </div>
        <div class="qrw-text-content-base-primary qrw-label-md">
          {{ form.total_score || $t("checklist_reports.none_score") }}
        </div>
      </div>
      <BaseIconButton
        icon="file-text"
        size="md"
        variant="ghost"
        textColor="content-base-tertiary"
        @click="openReport"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    form: Object,
  },
  data() {
    return {
      completenessHover: false,

      cardHover: false
    };
  },
  methods: {
    openReport() {
      this.$router.push({
        name: "checklist_report",
        params: {
          id: this.form._id,
        },
      });
    },
  },
  computed: {
    formWaiter() {
      return this.$store.state.waiters.find(
        (w) => w._id === this.form.waiter_id
      );
    },
    formattedFormTime() {
      return moment(this.form.completed_at).format("HH:mm");
    },
    completenessColor() {
      if (this.form.complete_percent === 100) return 'green-6';
      if (this.form.complete_percent <= 25) return 'red-5';

      return `orange-5`;
    },
    scheduleState() {
      if (!this.form.scheduled_at) return null;

      return {
        expired: this.form.is_expired,
        timeslot:
          moment(this.form.scheduled_at).format("HH:mm") +
          " - " +
          moment(this.form.ends_at).format("HH:mm"),
        date: moment(this.form.scheduled_at).format("DD.MM.YYYY"),
      };
    },
  },
};
</script>

<style scoped>
.checklist-report-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  column-gap: 12px;
}

.report-time {
  width: 48px;
  max-width: 48px;
  min-width: 48px;
}

.report-card {
  display: flex;
  flex-direction: row;
  column-gap: 32px;
  align-items: center;
  padding: 12px 12px 12px 24px;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
}

.report-scheduling {
  color: var(--qrw-content-base-secondary);
  white-space: nowrap;
}

.report-user,
.report-score {
  width: fit-content;
  white-space: nowrap;
}

.report-user {
  width: 160px;
  max-width: 160px;
  min-width: 160px;
}

.report-score,
.report-percent {
  width: 100px;
  max-width: 100px;
  min-width: 100px;
}

.report-form-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.expired {
  color: var(--qrw-content-error-primary);
}
</style>
